module.exports = __webpack_public_path__ + "static/media/vvce.ee22c649.png";